import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";
import { slugify } from "../../mock";

export default function OriginsSection({ commodity, origins }) {
  const [ref, visible] = useReveal();
  const cols = origins.items.length === 4 ? "md:grid-cols-2 lg:grid-cols-4" : "md:grid-cols-3";
  return (
    <section className="bg-[#ece2cf] py-24 md:py-32" data-testid="origins-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div ref={ref} className={`reveal ${visible ? "in-view" : ""}`}>
          <p className="text-[#7c5230] text-xs tracking-[0.25em] uppercase mb-6">{origins.index} · Sourced Directly · {origins.items[0].country}</p>
          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-light leading-[1.0] text-[#10271a] max-w-3xl">
            {origins.title} <em className="italic text-[#1f4a33]">{origins.emphasis}</em>
          </h2>
        </div>
        <div className={`mt-16 grid grid-cols-1 ${cols} gap-px bg-[#10271a]/10 rounded-3xl overflow-hidden border border-[#10271a]/10`}>
          {origins.items.map((o, i) => (
            <OriginCard key={o.no} commodity={commodity} origin={o} delay={i * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
}

function OriginCard({ commodity, origin, delay }) {
  const [ref, visible] = useReveal();
  const slug = slugify(origin.region);
  return (
    <Link to={`/origins/${commodity}/${slug}`} ref={ref} className={`group block bg-[#faf6ec] p-8 md:p-10 reveal hover:bg-[#fbf8f1] transition-colors ${visible ? "in-view" : ""}`} style={{ animationDelay: `${delay}s` }} data-testid={`origin-card-${slug}`}>
      <div className="flex items-center justify-between">
        <p className="text-[#7c5230] text-xs tracking-[0.2em] uppercase">{origin.no}</p>
        <ArrowUpRight size={18} className="text-[#1f4a33] opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all" />
      </div>
      <p className="mt-6 text-[#5e6b61] text-sm tracking-[0.1em] uppercase">{origin.country}</p>
      <h3 className="font-display text-3xl lg:text-4xl text-[#10271a] mt-1 leading-tight">{origin.region}</h3>
      <p className="mt-5 text-[#5e6b61] leading-relaxed">{origin.description}</p>
      <div className="mt-8 pt-6 border-t border-[#10271a]/10 space-y-3 text-sm">
        <Row label="Altitude" value={origin.altitude} />
        <Row label="Varietal" value={origin.varietal} />
        <Row label="Process" value={origin.process} />
      </div>
      <p className="mt-6 text-[12px] tracking-[0.12em] uppercase font-semibold text-[#1f4a33]">Explore region · map & harvest</p>
    </Link>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-start justify-between gap-4">
      <span className="text-[#7c5230] tracking-[0.12em] uppercase text-xs pt-0.5">{label}</span>
      <span className="text-[#10271a] font-medium text-right">{value}</span>
    </div>
  );
}
